import activity from '@shared/assets/icons/sets/de/activity.svg';
import bag from '@shared/assets/icons/sets/de/bag.svg';
import barChart from '@shared/assets/icons/sets/de/bar-chart.svg';
import clock from '@shared/assets/icons/sets/de/clock.svg';
import closeGray from '@shared/assets/icons/sets/de/close-gray.svg';
import cross from '@shared/assets/icons/sets/de/cross.svg';
import ctv from '@shared/assets/icons/sets/de/ctv.svg';
import danger from '@shared/assets/icons/sets/de/danger.svg';
import eye from '@shared/assets/icons/sets/de/eye.svg';
import filterGray from '@shared/assets/icons/sets/de/filters-gray.svg';
import gallery from '@shared/assets/icons/sets/de/gallery.svg';
import game from '@shared/assets/icons/sets/de/game.svg';
import gift from '@shared/assets/icons/sets/de/gift.svg';
import location from '@shared/assets/icons/sets/de/location.svg';
import paper from '@shared/assets/icons/sets/de/paper.svg';
import phone from '@shared/assets/icons/sets/de/phone.svg';
import pieChart from '@shared/assets/icons/sets/de/pie-chart.svg';
import star from '@shared/assets/icons/sets/de/star.svg';
import user from '@shared/assets/icons/sets/de/user.svg';
import video from '@shared/assets/icons/sets/de/video.svg';
import wallet from '@shared/assets/icons/sets/de/wallet.svg';
import lannerFormat from '@shared/assets/icons/sets/default/lanner-format.svg';
import thematicCluster from '@shared/assets/icons/sets/default/thematic-cluster.svg';
import thematicPackages from '@shared/assets/icons/sets/default/thematic-packages.svg';
import videoFormat from '@shared/assets/icons/sets/default/video-format.svg';
import walletChart from '@shared/assets/icons/sets/default/wallet-chart.svg';
import walletEdit from '@shared/assets/icons/sets/default/wallet-edit.svg';
import walletPlus from '@shared/assets/icons/sets/default/wallet-plus.svg';
import { IconVariants } from '@shared/components/Icon/IconMapper.ts';

export const deIconMap: Record<IconVariants, string> = {
  activity,
  barChart,
  bag,
  danger,
  eye,
  clock,
  gallery,
  game,
  gift,
  location,
  pieChart,
  star,
  user,
  video,
  wallet,
  walletChart,
  walletPlus,
  walletEdit,
  filterGray,
  closeGray,
  cross,
  ctv,
  phone,
  paper,
  lannerFormat,
  videoFormat,
  thematicPackages,
  thematicCluster,
};
